import register from "./_login/_register";
import dashboardFilters from "./_filters/_dashboardFilters";
import dashboardLogin from "./_login/_dashboardLogin";
import dashboardMenu from "./config/_dashboardMenu";
import dashboardDevolution from "./_ticket/_dashboardDevolution";
import account from "./_account/_account";
import occFiles2 from "./occ/_occ";
import alertDialog from "./_components/_alertDialog";
import TicketDevolution from "./_ticket/_devolution";
import Equipament from "./Equipament/_equipament";
import dashboardPreschedule from "./_ticket/_dashboardPreschedule";
import scheduler_stepper from "./_ticket/_scheduler_stepper";
import int009_post_scheduler from "./_ticket/_int009_post_scheduler";
import technicalTicket from "./_ticket/technical/_technicalTicket";
import technical_ticket_stepper from "./_ticket/technical/_technicalTicketStepper";
import int010_post_technical_ticket from "./_ticket/technical/_int010_post_technical_ticket";
import ticketTabControl from './_ticket/_ticketTabControl'
import technical_ticket_create from "./_ticket/technical/_technical_ticket_create";
import technical_ticket_message_queue from './_ticket/technical/_technicalTicketMessageQueue'
import finance_ticket from "./_finance/_finance_ticket";
import contestTicket from "./_ticket/contest/_contestTicket"
import constestTicketStepper from "./_ticket/contest/_contestTicketStepper"

export const reducers = {
  occFiles2: occFiles2,
  TicketDevolution: TicketDevolution,
  Equipament: Equipament,
  account: account,
  register: register,
  dashboardFilters: dashboardFilters,
  dashboardLogin: dashboardLogin,
  dashboardDevolution: dashboardDevolution,
  dashboardPreschedule,
  scheduler_stepper: scheduler_stepper,
  int009_post_scheduler: int009_post_scheduler,
  technicalTicket: technicalTicket,
  technical_ticket_stepper: technical_ticket_stepper,
  int010_post_technical_ticket: int010_post_technical_ticket,
  ticketTabControl: ticketTabControl,
  technical_ticket_create: technical_ticket_create,
  technical_ticket_message_queue: technical_ticket_message_queue,
  finance_ticket: finance_ticket,
  constestTicket: contestTicket,
  constestTicketStepper: constestTicketStepper,
  // Menu config
  dashboardMenu: dashboardMenu,
  // Components
  alertDialog: alertDialog,
};
